import { render, staticRenderFns } from "./SurnameText.vue?vue&type=template&id=a0dc372e&"
import script from "./SurnameText.vue?vue&type=script&lang=js&"
export * from "./SurnameText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports